import type { ReactNode } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import clsx from 'clsx';

type AdminModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  /** パネルの最大幅（デフォルト: max-w-[720px]） */
  maxWidth?: string;
  children: ReactNode;
  footer?: ReactNode;
  /** タイトル色（デフォルト: 青 #4188ff） */
  titleColor?: string;
  /** フルスクリーンに近いレイアウト（ItemDetailPopup用） */
  fullScreen?: boolean;
};

/** radix Dialog のラッパー */
export default function AdminModal({
  open,
  onClose,
  title,
  maxWidth = 'max-w-[720px]',
  children,
  footer,
  titleColor = 'text-[#4188ff]',
  fullScreen,
}: AdminModalProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose();
      }}
    >
      <DialogContent
        className={clsx(
          'flex w-full flex-col rounded-lg shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]! sm:m-2',
          maxWidth,
          fullScreen
            ? 'max-h-[calc(100vh-2rem)] self-stretch! p-6 sm:max-h-[calc(100vh-3rem)]'
            : 'p-12'
        )}
      >
        {/* radix a11y 用（見た目は下の h2 が担う） */}
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <div className="flex shrink-0 flex-col items-center gap-2">
          <h2 className={clsx('text-base font-bold', titleColor)}>{title}</h2>
          <div
            className={clsx(
              'h-px w-full',
              titleColor === 'text-[#ff4e4e]'
                ? 'bg-[#ff4e4e]'
                : titleColor === 'text-[#4188ff]'
                  ? 'bg-[#4188ff]'
                  : 'bg-border'
            )}
          />
        </div>
        <div className={clsx('mt-4', fullScreen && 'min-h-0 flex-1 overflow-y-auto')}>
          {children}
        </div>
        {footer && <div className="mt-8 shrink-0">{footer}</div>}
      </DialogContent>
    </Dialog>
  );
}
